import OPT_IN_REQUIRED_COUNTRIES from "constants/optInRequiredCountries";

const requiresOptIn = countryCode =>
  OPT_IN_REQUIRED_COUNTRIES.includes(countryCode);

export default requiresOptIn;
